import { Component } from "react";
import PropTypes from "prop-types";
import SimpleRenderer from "./SimpleRenderer";
import LinearProgress from "@material-ui/core/LinearProgress";
import AdHocInfo from "./AdHocInfo";
import InvoicesRenderer from "./UpcomingInvoicesRenderer";

export default class UpcomingRenderer extends Component {
  render() {
    let item = this.props.item;
    let pending = this.props.pending;
    let completed = this.props.completed;
    let adHocContent = [];

    if ((pending && pending.fetching) || (completed && completed.fetching)) {
      adHocContent.push(<LinearProgress />);
    }

    if (pending && pending.data && pending.data.length) {
      for (let i = 0; i < pending.data.length; i++) {
        let element = pending.data[i];
        if (element.CreditId == item.Guid)
          adHocContent.push(<AdHocInfo item={element} />);
      }
    }

    if (completed && completed.data && completed.data.length) {
      for (let i = 0; i < completed.data.length; i++) {
        let element = completed.data[i];
        if (element.CreditId == item.Guid)
          adHocContent.push(<AdHocInfo item={element} />);
      }
    }

    if (adHocContent.length == 0) {
      adHocContent = [
        <span key="span">
          No ad Hoc Payments registered
          <br />
        </span>,
      ];
    }

    return (
      <div>
        <h4>Upcoming</h4>
        <SimpleRenderer label={"Ad Hoc: "} />
        {adHocContent}
        <br />
        <SimpleRenderer label={"Previous planned: "} />
        {item.PreviousPlanned
          ? item.PreviousPlanned.map((planned, index) => {
              return (
                <InvoicesRenderer
                  key={"prev" + index}
                  planned={planned}
                  isOpen={true}
                  invoiceFee={item.InvoiceFee.Amount}
                  intermediationFee={item.IntermediationFee.Amount}
                />
              );
            })
          : undefined}
        <br />
        <SimpleRenderer label={"Upcoming Invoices: "} />
        {item.Planned
          ? item.Planned.map((planned, index) => {
              return (
                <InvoicesRenderer
                  key={index}
                  planned={planned}
                  isOpen={index < 3}
                  invoiceFee={item.InvoiceFee.Amount}
                  intermediationFee={item.IntermediationFee.Amount}
                />
              );
            })
          : undefined}
      </div>
    );
  }

  static propTypes = {
    item: PropTypes.object,
    pending: PropTypes.object,
    completed: PropTypes.object,
  };
}
